import { ThemeContext } from '../../../constants/themes';
import Type from '../../atoms/Type';
import Button from '../../atoms/Button';
import {ReactComponent as Logo} from '../../../assets/img/logo.svg';
import {ReactComponent as Moon} from '../../../assets/img/moon.svg';
import {ReactComponent as Settings} from '../../../assets/img/settings.svg';
import './index.css';
  
const Navbar = ({ authed = false, promptDashboard = false, promptSettings = true, redirectUri = 'dashboard' }) => {
   return (
      <ThemeContext.Consumer>
         {themeContext => (
            authed === true ?
            <div className="navbar-div" style={{backgroundColor: themeContext.theme.body}}>
               <div className="navbar-logo-name">
                  <Logo width={26} fill={themeContext.theme.text} />
                  <a href="/landing" style={{textDecoration: 'none', marginLeft: '4px'}}><Type type="h2">ReadMeThis</Type></a>
               </div>
               <div>
                  {promptDashboard ?
                     <Button type="secondary" value="Dashboard" href="/dashboard"/>
                     :
                     null
                  }
                  {promptSettings ?
                     <a href="/settings" style={{textDecoration: 'none', marginLeft: '4px'}}>
                        <Settings width={20} fill={themeContext.theme.text} style={{marginBottom: -4, padding: 0}} />
                     </a>
                     :
                     null
                  }
                  <a onClick={themeContext.toggleTheme} style={{textDecoration: 'none', marginLeft: '1em', cursor: 'pointer'}}>
                     <Moon width={19} fill={themeContext.theme.text} style={{marginBottom: -3.5, padding: 0}} />
                  </a>
               </div>
            </div>
            :
            <div className="navbar-div" style={{backgroundColor: themeContext.theme.body}}>
               <div className="navbar-logo-name">
                  <Logo width={26} fill={themeContext.theme.text} />
                  <a href="/landing" style={{textDecoration: 'none', marginLeft: '4px'}}><Type type="h2">ReadMeThis</Type></a>
               </div>
               <div>
                  <Button type="secondary" value="Login" href={`login/?redirectUri=${redirectUri}&authType=signin&defaultView=signin`}/>
                  <a onClick={themeContext.toggleTheme} style={{textDecoration: 'none', marginLeft: '1em', cursor: 'pointer'}}>
                     <Moon width={19} fill={themeContext.theme.text} style={{marginBottom: -3.5, padding: 0}} />
                  </a>
               </div>
            </div>
         )}
      </ThemeContext.Consumer>
   );
}
  
export default Navbar;